export default __webpack_public_path__ + "static/media/EM1930.34I-42983_-25690_0.2db09919.jpg";